// ToastContext.js
import React, { createContext, useContext, useState } from "react";
import Toast from "./Toast";

const ToastContext = createContext();

export const useToast = () => {
  return useContext(ToastContext);
};

export const ToastProvider = ({ children }) => {
  const [toast, setToast] = useState({
    message: "",
    type: null,
    icon: null,
    visible: false,
  });

  const showToast = (message, type, icon = null, duration = 3000) => {
    setToast({ message, type, icon, visible: true });

    setTimeout(() => {
      setToast({ message: "", type: null, icon: null, visible: false });
    }, duration);
  };

  return (
    <ToastContext.Provider value={showToast}>
      {children}
      {toast.visible && (
        <Toast
          message={toast.message}
          type={toast.type}
          icon={toast.icon}
          onClose={() =>
            setToast({
              message: "",
              type: toast.type,
              icon: null,
              visible: false,
            })
          }
        />
      )}
    </ToastContext.Provider>
  );
};
